var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 51 51",
    color: "#001B38",
    className: "play-button_svg__icon__StyledIconSvg-sc-1yxsvte-0 play-button_svg__itSvbk play-button_svg__videos__StyledIcon-sc-1397vp6-10 play-button_svg__FJfSQ",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.132,
    cy: 25.132,
    r: 25.132,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.668 25.13l-17.014 8.856v-17.71l17.014 8.855z"
  }))));
}
var MemoSvgPlayButton = /*#__PURE__*/React.memo(SvgPlayButton);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0iMCAwIDUxIDUxIiBuYW1lPSJ2aWRlb1BsYXlGcm9udFBhZ2UiIGNvbG9yPSIjMDAxQjM4IiBjbGFzcz0iaWNvbl9fU3R5bGVkSWNvblN2Zy1zYy0xeXhzdnRlLTAgaXRTdmJrIHZpZGVvc19fU3R5bGVkSWNvbi1zYy0xMzk3dnA2LTEwIEZKZlNRIj48ZyBvcGFjaXR5PSIuOSI+PGNpcmNsZSBjeD0iMjUuMTMyIiBjeT0iMjUuMTMyIiByPSIyNS4xMzIiIGZpbGw9IiNmZmYiPjwvY2lyY2xlPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTM1LjY2OCAyNS4xMzA5TDE4LjY1NCAzMy45ODU2TDE4LjY1NCAxNi4yNzYxTDM1LjY2OCAyNS4xMzA5WiI+PC9wYXRoPjwvZz48L3N2Zz4K";
export { MemoSvgPlayButton as ReactComponent };